import { render, staticRenderFns } from "./DailyTasks.vue?vue&type=template&id=5f580c72&scoped=true"
import script from "./DailyTasks.vue?vue&type=script&lang=js"
export * from "./DailyTasks.vue?vue&type=script&lang=js"
import style0 from "./DailyTasks.vue?vue&type=style&index=0&id=5f580c72&prod&lang=less&scoped=true"
import style1 from "./DailyTasks.vue?vue&type=style&index=1&id=5f580c72&prod&lang=less&scoped=true"
import style2 from "./DailyTasks.vue?vue&type=style&index=2&id=5f580c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f580c72",
  null
  
)

export default component.exports